import { IApplicationState } from '../../types/redux';
import { TGetEstimationSaleWebRequest } from '../../repositories/price-estimator/v1/get-estimation-sale-web';
import { TGetEstimationRentWebRequest } from '../../repositories/price-estimator/v1/get-estimation-rent-web';
import { TGetEstimationSuburbanRequest } from '../../repositories/price-estimator/v1/get-estimation-suburban';
import { selectMappedPreciseFilters } from '../preciseFilters';
import { selectEstimationId, selectOfferId } from '../page';
import { ECategory } from '../../repositories/price-estimator/entities/estimation_suburban/EstimationSuburbanRequestSchema';

export type TReturn = TGetEstimationSaleWebRequest & TGetEstimationRentWebRequest;

/** Возвращает необходимые параметры для апи оценки по продаже и аренде, хранящиеся в сторе */
export const selectApiParameters = (state: IApplicationState): TReturn => ({
  address: state.filters.address,
  area: state.filters.area as number,
  roomsCount: state.filters.roomsCount as TReturn['roomsCount'],
  filters: selectMappedPreciseFilters(state),
  offerId: selectOfferId(state),
  estimationId: selectEstimationId(state),
});

export const selectSuburbanApiParameters = (state: IApplicationState): TGetEstimationSuburbanRequest => ({
  address: state.filters.address,
  landArea: state.filters.landArea as number,
  houseArea: state.filters.houseArea,
  estimationId: selectEstimationId(state),
  category: state.filters.category as unknown as ECategory,
  filters: selectMappedPreciseFilters(state),
  lat: state.page.queryParams.lat,
  lng: state.page.queryParams.lng,
});
